import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import { BankBicOption } from '../../models/bank-account-form.model';

@Injectable({ providedIn: 'root' })
export class BankAccountFormLookupsFacade {
  private bics$: Observable<BankBicOption[]> | null = null;

  constructor(private http: HttpClient) { }

  bics(): Promise<BankBicOption[]> {
    if (!this.bics$) {
      this.bics$ = this.http.get<any>(`${environment.apiUrl}/bankaccounts/bics`).pipe(
        map(response => ((response && response.data) || [])
          .map((b: any) => ({ bic: String(b.bic || ''), bank: String(b.bank || '') }))
          .filter((b: BankBicOption) => !!b.bic)),
        catchError(error => {
          this.bics$ = null;
          return throwError(() => error);
        }),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
    }
    return firstValueFrom(this.bics$);
  }
}
